import React from 'react';
import proptypes from 'prop-types';
import classNames from 'classnames';
import { Typography } from '@one-thd/sui-atomic-components';

const { string, bool } = proptypes;

const CarouselHeader = ({ title, subtitle, noPipSpacing = false }) => (
  <div className={classNames('sui-mb-2', { 'sui-mt-0': noPipSpacing, 'sui-mt-4': !noPipSpacing })}>
    <div className="sui-mb-3">
      <Typography variant="h2">
        {title}
        {subtitle?.toLowerCase() === 'sponsored' && (
          <span
            className="sui-font-regular sui-text-base sui-text-subtle sui-float-right sui-mr-4"
          >
            {subtitle}
          </span>
        )}
      </Typography>
      {subtitle && subtitle?.toLowerCase() !== 'sponsored' && (
        <div className="sui-mb-3">
          <Typography variant="h3">{subtitle}</Typography>
        </div>
      )}
    </div>
  </div>
);

CarouselHeader.propTypes = {
  title: string,
  subtitle: string,
  noPipSpacing: bool
};

CarouselHeader.defaultProps = {
  title: '',
  subtitle: null
};

export { CarouselHeader };
